<template>
  <main>



    <div class="row">
      <div class="col s12 l10 offset-l1 card-panel recargas">
        <div class="row center-align" style="margin-bottom: 0%;">
          <div class=" page-title">
            <span>Lineas Sin Registro</span>
          </div>
          <div >
            <span class="page-title"> {{ computedList.length }} encontrados</span>
          </div>
          <div class="row center-align" style="margin-bottom: 0%;">
            <div class="col s6 m3 offset-m3 l2 offset-l4 input-date" style="cursor: pointer;">
              <link
                  rel="stylesheet"
                  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
              />
              <div class="center-align " @click="dateIni">
            <span
                class="material-symbols-outlined btn-style color"
                style="position: relative; top: 4px;"
            >today</span
            >
                <span
                    class="prefix"
                    style="font-size: 18px; width: 6rem; top: 0.2rem;"
                >Fecha Inicial:</span
                >
              </div>
              <input
                  id="input-fecha-inicial"
                  type="text"
                  class="datepicker center-align"
                  style="cursor: pointer;"
              />
            </div>

            <div class="col s6 m3 l2 input-date" style="cursor: pointer;">
              <link
                  rel="stylesheet"
                  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
              />
              <div class="center-align" @click="dateFin">
            <span
                class="material-symbols-outlined btn-style "
                style="position: relative; top: 4px;"
            >event</span
            >
                <span
                    class="prefix"
                    style="font-size: 18px; width: 6rem; top: 0.2rem;"
                >Fecha Final:</span
                >
              </div>
              <input
                  id="input-fecha-final"
                  type="text"
                  class="datepicker center-align"
                  style="cursor: pointer;"
              />
            </div>
          </div>

        </div>


        <div id="app">
          <div class="col s6 left-align"></div>
          <div class="col s6 right-align">
            <div
                class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                @click="toggleFiltros"
                data-position="top"
                :data-tooltip="mostrarFiltros ? 'Ocultar Filtros' : 'Mostrar Filtros'"
            >
              <link
                  rel="stylesheet"

                  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
              />
              <span 
              class="material-symbols-outlined btn-style" >
              {{ mostrarFiltros ? 'filter_alt' : 'filter_alt_off' }}
            </span>
            </div>
            
            <div
                class="waves-effect waves-light btn tooltipped blue-grey darken-3"
                @click="generarExcel"
                data-position="top"
                data-tooltip="Generar Excel"
            >
              <i class="fa fa-file-excel-o " aria-hidden="true"></i>

              <input
                  v-show="mostrarExcel"
                  id="input-fecha"
                  type="text"
                  placeholder="Fecha de expiracion"
                  class="datepickerFecha ancho-fecha"
                  style="width: 131px; right: 93px; position: absolute; top: 55px"
              />
            </div>
          </div>

          <div class="row" v-show="mostrarFiltros" v-if="!isBisvi">

            <div
                class="column col s6 m6 l2 xl2"
                v-for="titulo in titulos" v-if="!(empresa == 'discovery' && titulo.llave == 'monto' && !isAdmin)"

            >

              <div class="chips validate input-filtros" :id="titulo.llave">

                <input
                    class="chip-input"
                    :id="'input-' + titulo.llave"
                    @focusout="handleFocusOut(titulo.llave)"
                />
              </div>
            </div>
          </div>
          <div class="row" v-show="mostrarFiltros" v-else>

            <div
                class="column col s6 m6 l2 xl2"
                v-for="titulo in titulosBisvi"

            >

              <div class="chips validate input-filtros" :id="titulo.llave">
                <!--               <i class="material-icons icon-chips">filter_list</i> -->
                <input
                    class="chip-input"
                    :id="'input-' + titulo.llave"
                    @focusout="handleFocusOut(titulo.llave)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>


      <form enctype="multipart/form-data" v-show="false" id="formulario">
        <input
            type="file"
            id="archivo"
            name="archivo"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        />
      </form>

      <div class="table col s12 l10 push-l1">
        <div class="">
          <table
              class="responsive-table striped highlight "
              style="text-align-last: center"
          >
            <thead >
            <tr>

              <th v-for="titulo in titulos">
                <p>{{ titulo.valor }}</p>
              </th>
              <th >
                <p>Fecha de Registo</p>
              </th>
              <th v-if="empresa =='demo' || empresa =='activasim' ||  empresa =='teletrial'">
                <p>Liberar</p>
              </th>
              <th >
                <p>Recarga</p>
              </th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="(fila, index) in agregar100">
              <td >
                <p>{{ fila.icc }}</p>
              </td>

              <td >
                <p>{{ fila.dn }}</p>
              </td>

              <td>
                <p>${{ fila.monto }}</p>
              </td>
              <td>
                <p>{{ fila.compania }}</p>
              </td>

              <td>
                <p>{{ fila.fechaSubida }}</p>
              </td>
              <td>
                <p>{{ fila.fechaActivacion }}</p>
              </td>

              <td v-if="isPlataforma">
                <p>{{ fila.plataforma }}</p>
              </td>

              <td >
                <p v-show="fila.fechaRegistro" >{{ fila.fechaRegistro }}</p>
                <div v-show="!fila.fechaRegistro "
                     class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                     data-position="top"
                     :class="botondesactivado"
                     data-tooltip="Consultar"
                     @click="checkRegistro(fila.dn, fila.compania)"
                >
                  <link
                      rel="stylesheet"
                      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
                  />
                  <span class="material-symbols-outlined btn-style">
                        <span class="material-symbols-outlined">
                          <span class="material-symbols-outlined">
                            mobile_friendly
                          </span>
                        </span>
                      </span>
                </div>
              </td>
              <td v-if="empresa =='demo' || empresa =='activasim' ||  empresa =='teletrial' ">
                <p v-show="fila.fechaRegistro" >Liberado</p>
                <div v-show="!fila.fechaRegistro"
                     class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                     data-position="top"
                     data-tooltip="Recargar"
                     @click="liberarRecarga(fila.dn)"

                >
                  <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0&icon_names=check" />
                  <span class="material-symbols-outlined btn-style">
                        <span class="material-symbols-outlined">
                          <span class="material-symbols-outlined">
check
</span>
                        </span>
                      </span>
                </div>
              </td>
              <td >
                <p v-show="!fila.fechaRegistro" >Aun no se puede Recargar</p>
                <div v-show="fila.fechaRegistro"
                     class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                     data-position="top"
                     data-tooltip="Recargar"
                     @click="recargarRegistro(fila.dn)"

                >
                  <link
                      rel="stylesheet"
                      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
                  />
                  <span class="material-symbols-outlined btn-style">
                        <span class="material-symbols-outlined">
                          <span class="material-symbols-outlined">
                            mobile_friendly
                          </span>
                        </span>
                      </span>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import {creaExcel, getIccsSinRegistro, plataformaCarrier, checkStatusIccsSinRegistro, recargaRegistro, liberarRecarga} from "@/api/api";
import {activateLine} from "@/api/iccs";
import {actualizarIcc, plataformasEmpresa, getEmpresas} from "@/api/api";
import {controles, i18n} from "@/constantes";
import ModalVentas from "./modalVentas.vue";
import {mapState} from "vuex";
import {emitter} from "@/eventBus";

let copyTitulos = [];

let filtros = {};
let usuario;

export default {
  name: "administrarRegistro",
  data() {
    return {
      showMessageRange: false,
      showMessageOld: false,
      isEdit: false,
      titulo: "Cargando...",
      titulos: [
        {llave: "icc", valor: "Icc"},
        {llave: "dn", valor: "DN"},
        {llave: "monto", valor: "Monto"},
        {llave: "compania", valor: "compañia"},
        {llave: "fechaSubida", valor: "Subida"},
        {llave: "fechaActivacion", valor: "Venta"},
        {llave: "plataforma", valor: "plataforma"},
      ],

      mostrarExcel: false,
      nirEditar: "",
      cuerpos: [],
      filaEditar: "0",
      iccEdit: "",
      dnEdit: "",
      montoEdit: "",
      liderEdit: "",
      clienteEdit: "",
      miNivel: "",
      isPlataforma: false,
      isBisvi: false,
      chips: [],
      chipsOptions: {
        onChipAdd: this.addChip,
        onChipDelete: this.deleteChip,
      },
      datosRecibios: [],
      datosAMostrar: [],
      indexScroll: 1,
      mostrarFiltros: true,
      permisoDesbloquear: false,
      botondesactivado: '',
      fechaIni: "",
      fechaFin: "",
      isMonto: true,
      idEditar: '',
      googleCode: '',
      latitude: '',
      longitude: '',
      empresa: window.localStorage.getItem('empresa')
    };
  },
  methods: {
    recargarRegistro(dn){
      this.$store.commit("ponerBarra");
      return recargaRegistro(dn).then(resp=>{
        M.toast({
          html: `Recarga Exitosa`,
          classes: "rounded",
          displayLength: 15000,
        });
        this.traerIccsFechas(0,0)
        console.log(resp)
      }).catch(error=>{
        console.log(error)
        this.$store.commit("quitarBarra");
        M.toast({
          html: `${error.mensaje}`,
          classes: "rounded",
          displayLength: 15000,
        });
      })
    },
    liberarRecarga(dn ){
      this.$store.commit("ponerBarra");
      liberarRecarga(dn).then(resp =>{
        this.traerIccsFechas(0,0)
        M.toast({
          html: `${resp.mensaje}`,
          classes: "rounded",
          displayLength: 15000,
        });
        this.$store.commit("quitarBarra");
        console.log(resp)
      }).catch(error=>{
        console.log(error)
        this.$store.commit("quitarBarra");
        M.toast({
          html: `${error.mensaje}`,
          classes: "rounded",
          displayLength: 15000,
        });
      })
    },
    checkRegistro(dn, carrier){
      this.botondesactivado = ` disabled`
      this.$store.commit("ponerBarra");
      let Contype = 2
      // if((carrier == 'AT&T' || carrier == 'Unefon' ) && this.empresa != 'demo' ){
      //
      //   M.toast({
      //     html: `Sin registro`,
      //     classes: "rounded",
      //     displayLength: 1500,
      //   });
      //   return false;
      // }
      if(carrier == 'Movistar' || carrier == 'Telcel'){
        Contype = 1
      }
      return checkStatusIccsSinRegistro(dn, Contype).then(resp =>{
        if(resp.status == 1){
          this.traerIccsFechas(0,0)
        }
        M.toast({
          html: `${resp.mensaje}`,
          classes: "rounded",
          displayLength: 15000,
        });
        this.$store.commit("quitarBarra");
        this.botondesactivado = ``
        console.log(resp)
      }).catch(error=>{
        console.log(error)
        this.$store.commit("quitarBarra");
        this.botondesactivado = ``
        M.toast({
          html: `${error.mensaje}`,
          classes: "rounded",
          displayLength: 15000,
        });
      })

    },
    fIsControler(ruta) {
      if (this.miNivel != 1) {
        console.log(`en le nivel`)
        return false
      }
      const empresa = controles[`${this.empresa}`]
      if (!empresa) {
        console.log(`en la empresa`)
        return true
      }
      const user = empresa.find(e => e.user == localStorage.username)
      if (!user) {
        console.log(`en el user`)
        return true
      }
      const rutaValida = user.rutas.find(r => r == ruta)
      if (rutaValida) {
        console.log(`en la ruta`)
        return false
      }

      return true
    },
    dateIni() {
      const elem = document.getElementById("input-fecha-inicial");
      const instance = M.Datepicker.getInstance(elem);
      instance.open();
      console.log("wea");
    },
    dateFin() {
      const elem = document.getElementById("input-fecha-final");
      const instance = M.Datepicker.getInstance(elem);
      instance.open();
    },
    toggleFiltros() {
      this.mostrarFiltros = !this.mostrarFiltros;
    },
    handleFocusOut(llave) {
      const inputId = "input-" + llave;
      const input = document.getElementById(inputId);
      input.dispatchEvent(
          new KeyboardEvent("keydown", {
            key: "Enter",
            code: "Enter",
            keyCode: 13,
            which: 13,
          })
      );
    },
    initChips() {
      if (this.isBisvi) {
        this.titulosBisvi.forEach((titulo) => {
          const elems = document.getElementById(titulo.llave);
          const chipsOptions = {
            ...this.chipsOptions,
            key: titulo.llave,
            placeholder: `${titulo.valor}`,
          };
          const chip = M.Chips.init(elems, chipsOptions);
        });
      } else {
        this.titulos.forEach((titulo) => {
          const elems = document.getElementById(titulo.llave);
          const chipsOptions = {
            ...this.chipsOptions,
            key: titulo.llave,
            placeholder: `${titulo.valor}`,
          };
          const chip = M.Chips.init(elems, chipsOptions);
        });
      }
    },

    deleteChip(a, b) {
      const key = a[0].M_Chips.options.key;
      const value = b.firstChild.textContent;
      this.chips = this.chips.filter(
          (c) => !(c.key === key && c.value === value)
      );
      console.log(this.chips);
    },
    addChip(a, b) {
      const key = a[0].M_Chips.options.key;
      const value = b.firstChild.textContent;
      this.chips.push({key, value});
      console.log(this.chips);
    },

    generarExcel() {
      console.log("por generar excel loco");
      this.$store.commit("ponerBarra");

      let fechaIni = document
          .getElementById("input-fecha-inicial")
          .value.trim();
      let fechaFin = document.getElementById("input-fecha-final").value.trim();
      let diaIni, mesIni, anioIni, diaFin, mesFin, anioFin;
      if (fechaIni.length > 2) {
        const fechaSeparada = fechaIni.split("/");
        diaIni = fechaSeparada[2];
        mesIni = fechaSeparada[1];
        anioIni = fechaSeparada[0];
      }
      if (fechaFin.length > 2) {
        const fechaSeparada = fechaFin.split("/");
        diaFin = fechaSeparada[2];
        mesFin = fechaSeparada[1];
        anioFin = fechaSeparada[0];
      }
      const fechas = {
        diaIni,
        mesIni,
        anioIni,
        diaFin,
        mesFin,
        anioFin,
      };
      console.log(`1132312321`);
      creaExcel(this.chips, "REGISTROS", fechas)
          .then((response) => {
            this.$store.commit("quitarBarra");
            if (window.location.href.includes("recargasasec.com")) {
              console.log(process.env.NODE_ENV);

              window.location =
                  process.env.NODE_ENV == "productionCam"
                      ? `https://recargasasec.com/excel?nombre=${response.data.nombreArchivo}`
                      : `http://localhost:8091/excel?nombre=${response.data.nombreArchivo}`;
            } else {
              window.location =
                  process.env.NODE_ENV === "production"
                      ? `https://recarga-te.com/excel?nombre=${response.data.nombreArchivo}`
                      : `http://localhost:8091/excel?nombre=${response.data.nombreArchivo}`;
            }
          })
          .catch((error) => {
            this.$store.commit("quitarBarra");
            console.log(error);
            M.toast({
              html: "No se pudo crear el excel",
              classes: "rounded",
              displayLength: 3000,
            });
          });
    },
    traerIccs(contador, offset) {
      if (contador === 0) {
        this.datosRecibios = []
        this.datosAMostrar = []
      }

      let fechaIni = document
          .getElementById("input-fecha-inicial")
          .value.trim();
      let fechaFin = document.getElementById("input-fecha-final").value.trim();
      if (!fechaIni) {
        const date = new Date();
        const dia = date.getDate() > 27 ? 27 : date.getDate();
        const mes =
            date.getMonth() == 0
                ? 11
                : date.getMonth() == 1
                ? 12
                : date.getMonth() - 1;
        const anio =
            date.getMonth() == 0 || date.getMonth() == 1
                ? date.getFullYear() - 1
                : date.getFullYear();
        fechaIni = `${anio}/${mes}/${dia}`;

          document.getElementById("input-fecha-inicial").value = fechaIni;
      }
      if (!fechaFin) {
        const date = new Date();
        fechaFin = `${date.getFullYear()}/${date.getMonth() +1}/${date.getDate()}`;
        document.getElementById("input-fecha-final").value = fechaFin;
      }
      let diaIni, mesIni, anioIni, diaFin, mesFin, anioFin;
      if (fechaIni.length > 2) {
        const fechaSeparada = fechaIni.split("/");
        diaIni = fechaSeparada[2];
        mesIni = fechaSeparada[1];
        anioIni = fechaSeparada[0];
      }
      if (fechaFin.length > 2) {
        const fechaSeparada = fechaFin.split("/");
        diaFin = fechaSeparada[2];
        mesFin = fechaSeparada[1];
        anioFin = fechaSeparada[0];
      }

      this.$store.commit("ponerBarra");

      let defaults;
      let plataformas, plataformasC;
      getEmpresas()
          .then((resp) => {
            defaults =
                resp.data.noPlataforma == 2
                    ? `${resp.data.usuario2} (${resp.data.plataforma2})(General)`
                    : `${resp.data.usuario} (${resp.data.plataforma})(General)`
            return plataformasEmpresa()
          })
          .then((resp) => {
            plataformas = resp.data
            return plataformaCarrier()
          })
          .then((resss) => {
            plataformasC = resss.data

              return getIccsSinRegistro(
                  contador,
                  offset,
                  diaIni,
                  mesIni,
                  anioIni,
                  diaFin,
                  mesFin,
                  anioFin
              );
          })
          .then((response) => {

            console.log(response, `esta es la eresp[k`);
            this.isPlataforma = response.titulos.find(
                (t) => t.llave == `plataforma`
            )
                ? true
                : false;
            this.miNivel = localStorage.nivel + "";
            if (this.miNivel != 1) {
              this.isPlataforma = false;
            }

            copyTitulos = response.titulos.slice();
            response.titulos.forEach((titulo) => (filtros[titulo.llave] = ""));

            if (this.isPlataforma)
              response.iccs = response.iccs.map((i) => {
                const auxcomp = i.compania;
                const comp = i.compania.split(" ");
                i.compania = comp[0];
                let c = `T`;
                if (i.compania == `Movistar`) c = `M`;
                if (i.compania == `AT&T`) c = `A`;
                if (i.compania == `Unefon`) c = `U`;
                i.compania = auxcomp;
                //console.log(i.plataforma)
                //console.log(plataformas);
                const plataformaAux = plataformas.find(
                    (p) => p.id == i.plataforma
                );
                const plataformaAux2 = plataformasC.find((p) => p.carrier == c)
                    ? plataformasC.find((p) => p.carrier == c)
                    : defaults;
                const plataformaAux3 = plataformaAux
                    ? plataformaAux
                    : plataformas.find(
                        (p) => p.id == plataformaAux2.empresaPlataformaId
                    );
                const typeaux = plataformaAux ? `(Archivo)` : `(Carrier)`;
                if (i.dn == 5634098121)
                  console.log(
                      `4645465465`,
                      plataformaAux2,
                      plataformaAux3,
                      plataformas,
                      i
                  );
                const plataforma = plataformaAux3
                    ? `${plataformaAux3.plataforma}(${plataformaAux3.usuario})${typeaux}`
                    : `No aplica ${defaults}`;
                return {
                  ...i,
                  plataforma,
                };
              });

            this.datosRecibios = this.datosRecibios.concat(response.iccs.slice());
            usuario = localStorage.id;
            this.datosAMostrar = this.datosAMostrar.concat(response.iccs.slice());


            // this.datosRecibios = response.iccs.slice();
            // usuario = localStorage.id;
            // this.datosAMostrar = response.iccs.slice();
            console.log(this.datosRecibios.length, `datso a smosskj`);
            this.titulo = `${this.datosRecibios.length} encontrados`;
            //M.AutoInit()
            /*         this.agregar100(); */
            if (response.iccs.length > 0) {
              this.traerIccs(++contador)
            } else {
              console.log("se quita barra");
              this.$store.commit("quitarBarra");
              $(".input-filtros").prop("disabled", false);
            }
          })
          .catch((error) => {
            this.$store.commit("quitarBarra");
            console.log(error);
          });
    },

    traerIccsFechas(contador, offset) {

      if (contador === 0) {
        this.datosAMostrar = [];
        this.datosRecibios = [];
      }

      let fechaIni = document
          .getElementById("input-fecha-inicial")
          .value.trim();
      let fechaFin = document.getElementById("input-fecha-final").value.trim();
      let initialDate = new Date(fechaIni);
      let finalDate = new Date(fechaFin);

      let actualDate = new Date();
      let fechasDif = finalDate - initialDate;


      if (!fechaIni) {
        const date = new Date();
        const dia = date.getDate() > 27 ? 27 : date.getDate();
        const mes =
            date.getMonth() == 0
                ? 11
                : date.getMonth() == 1
                ? 12
                : date.getMonth() - 1;
        const anio =
            date.getMonth() == 0 || date.getMonth() == 1
                ? date.getFullYear() - 1
                : date.getFullYear();
        fechaIni = `${anio}/${mes}/${dia}`;
        document.getElementById("input-fecha-inicial").value = fechaIni;
      }
      if (!fechaFin) {
        const date = new Date();
        fechaFin = `${date.getFullYear()}/${date.getMonth() +
        1}/${date.getDate()}`;
        document.getElementById("input-fecha-final").value = fechaFin;
      }
      let diaIni, mesIni, anioIni, diaFin, mesFin, anioFin;
      if (fechaIni.length > 2) {
        const fechaSeparada = fechaIni.split("/");
        diaIni = fechaSeparada[2];
        mesIni = fechaSeparada[1];
        anioIni = fechaSeparada[0];
      }
      if (fechaFin.length > 2) {
        const fechaSeparada = fechaFin.split("/");
        diaFin = fechaSeparada[2];
        mesFin = fechaSeparada[1];
        anioFin = fechaSeparada[0];
      }

      this.$store.commit("ponerBarra");

      let defaults;
      let plataformas, plataformasC;
      getEmpresas()
          .then((resp) => {
            defaults =
                resp.data.noPlataforma == 2
                    ? `${resp.data.usuario2} (${resp.data.plataforma2})(General)`
                    : `${resp.data.usuario} (${resp.data.plataforma})(General)`;
            return plataformasEmpresa();
          })
          .then((resp) => {
            plataformas = resp.data;

            return plataformaCarrier();
          })
          .then((resss) => {
            plataformasC = resss.data;
            return getIccsSinRegistro(
                contador,
                offset,
                diaIni,
                mesIni,
                anioIni,
                diaFin,
                mesFin,
                anioFin
            );
          })
          .then((response) => {
            this.$store.commit("quitarBarra");
            /*     this.titulos = response.titulos.slice(); */
            this.isPlataforma = response.titulos.find(
                (t) => t.llave == `plataforma`
            )
                ? true
                : false;
            this.miNivel = localStorage.nivel + "";
            if (this.miNivel != 1) {
              this.isPlataforma = false;
            }

            copyTitulos = response.titulos.slice();
            response.titulos.forEach((titulo) => (filtros[titulo.llave] = ""));
            console.log(defaults);
            if (this.isPlataforma)
              response.iccs = response.iccs.map((i) => {
                const auxcomp = i.compania;
                const comp = i.compania.split(" ");
                i.compania = comp[0];
                let c = `T`;
                if (i.compania == `Movistar`) c = `M`;
                if (i.compania == `AT&T`) c = `A`;
                if (i.compania == `Unefon`) c = `U`;
                i.compania = auxcomp;
                const plataformaAux = plataformas.find(
                    (p) => p.id == i.plataforma
                );
                const plataformaAux2 = plataformasC.find((p) => p.carrier == c)
                    ? plataformasC.find((p) => p.carrier == c)
                    : defaults;
                const plataformaAux3 = plataformaAux
                    ? plataformaAux
                    : plataformas.find(
                        (p) => p.id == plataformaAux2.empresaPlataformaId
                    );
                const typeaux = plataformaAux ? `(Archivo)` : `(Carrier)`;

                const plataforma = plataformaAux3
                    ? `${plataformaAux3.plataforma}(${plataformaAux3.usuario})${typeaux}`
                    : `No aplica ${defaults}`;
                return {
                  ...i,
                  plataforma,
                };
              });
            this.datosRecibios = this.datosRecibios.concat(response.iccs.slice());
            usuario = localStorage.id;
            this.datosAMostrar = this.datosAMostrar.concat(response.iccs.slice());

            this.titulo = `${this.datosRecibios.length} encontrados`;
            //this.agregar100()
            console.log(
                this.datosAMostrar.length,
                this.datosRecibios.length,
                response.iccs.length
            );
            if (response.iccs.length > 0) {
              this.traerIccsFechas(++contador);
            } else {
              this.$emit("quitarBarra");
              $(".input-filtros").prop("disabled", false);
            }
          })
          .catch((error) => {
            this.$store.commit("quitarBarra");
            console.log(error);
          });
    },



  },
  computed: {
    ...mapState(["permisos", "isAdmin"]),
    computedList() {
      this.datosAMostrar = this.datosRecibios.slice();
      console.log(this.titulo);
      if (this.chips.length) {
        let auxChips = this.chips.slice();
        let chipsArray = [];
        while (auxChips.length) {
          let chip = auxChips[0];
          chipsArray.push(
              auxChips.filter((auxChip) => auxChip.key == chip.key)
          );
          auxChips = auxChips.filter((auxChip) => auxChip.key != chip.key);
        }
        let auxDatosAMostrar = this.datosAMostrar.slice();
        chipsArray.forEach((element) => {
          auxDatosAMostrar = auxDatosAMostrar.filter((item) => {
            return element.some((titulo) => {
              return item[titulo.key]
                  .toUpperCase()
                  .includes(titulo.value.toUpperCase());
            });
          });
        });
        this.datosAMostrar = auxDatosAMostrar;
        console.log("Termino");
        console.log(this.datosAMostrar.length);
      }
      return this.datosAMostrar;
    },
    agregar100() {
      return this.computedList.slice(0, 20 * this.indexScroll);
    },
  },
  created() {
    if (usuario !== localStorage.id) {
      this.cuerpos = [];
      this.datosAMostrar = [];
      this.datosRecibios = [];
    }
  },
  beforeDestroy(){
    emitter.off('enviarCodigo')
  },
  mounted() {

    this.miNivel = localStorage.nivel;
    const permisos = `${localStorage.permisos}`;

    this.$nextTick(() => {
      setTimeout(() => {
        M.AutoInit()
        this.initChips();
        console.log(`aqui empieza`);
        const fechaInicialInput = document.querySelector(
            "#input-fecha-inicial"
        );
        const fechaFinalInput = document.querySelector("#input-fecha-final");

        M.Datepicker.init(fechaInicialInput, {
          format: "yyyy/mm/dd",
          i18n: i18n,
          onClose: () => {
            // Llama a consultar cuando se cierra el datepicker de fecha inicial
            this.traerIccsFechas(0, 0);
          },
        });

        M.Datepicker.init(fechaFinalInput, {
          format: "yyyy/mm/dd",
          i18n: i18n,
          onClose: () => {
            // Llama a consultar cuando se cierra el datepicker de fecha final
            this.traerIccsFechas(0, 0);
          },
        });

        M.updateTextFields();

      }, 1000);

      console.log(`aqui termina`);
      this.traerIccs(0, 0);
      $(window).scroll(() => {
        if ($(document).height() < $(window).scrollTop() + $(window).height() + 50) {
          /*    this.agregar100(); */
          this.indexScroll++;
        }
      });
    });
  },


};
</script>

<style scoped>
.datepicker {
  border-bottom: none !important;
}

.page-title {
  font-weight: inherit;
  font-size: 24px;
  margin-top: auto;
  margin-bottom: auto;
  list-style-type: none;
  display: inline-block;
  padding: 0.75rem 0 1rem;
  color: rgba(0, 0, 0, 0.623);
  -webkit-animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@-webkit-keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}

@keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}

.btn {
  width: 70px;
  text-align-last: center;
}

.btn-style {
  margin-top: 5px;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #aeafb7;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #656772;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #aeafb7;
}

.table-responsive {
  display: block;
  overflow-x: auto;
  width: 100%;
  text-align-last: center;
}

.table {
  padding: 0px !important;
  font-size: 0.9rem;
}

@media screen and (max-width: 600px) {
  table.striped.highlight th {
    font-size: 14px;
    white-space: nowrap;
  }
}

* {
  box-sizing: border-box !important;
}

.search-box {
  width: fit-content !important;
  height: fit-content !important;
  position: relative !important;
}

.input-search {
  height: 50px !important;
  width: 50px !important;
  border-style: none !important;
  padding: 10px !important;
  font-size: 18px !important;
  letter-spacing: 2px !important;
  outline: none !important;
  border-radius: 25px !important;
  transition: all 0.5s ease-in-out !important;
  background-color: #22a6b3 !important;
  padding-right: 40px !important;
  color: black !important;
}

.input-search::placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
  font-size: 18px !important;
  letter-spacing: 2px !important;
  font-weight: 100 !important;
}

.input-search:focus {
  width: 300px !important;
  border-radius: 0px !important;
  background-color: transparent !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5) !important;
  transition: all 500ms cubic-bezier(0, 0.11, 0.35, 2) !important;
}

.icon-chips {
  font-size: 15px;
}

.titulo {
  font-size: 2.5em;
  font-family: "Roboto", serif;
  font-weight: lighter;

  border-radius: 1rem;

  margin-top: 5px;
}

.titulo-card {
  font-size: 2.5em;
  font-family: "Roboto", serif;
  margin-bottom: 10px;
}

table {
  background-color: #ffffff;
  border-radius: 0.5rem;
  margin-top: 0.5rem;
}

td,
th {
  padding: 15px 5px;
  display: table-cell;
  text-align: center !important;
  vertical-align: middle;
  border-radius: 2px;
}

/*.input-field {*/
/*  margin: 0;*/
/*}*/

.margen-titulo {
  margin-bottom: 12px;
}

.material-symbols-outlined {
  line-height: normal;
}

.fixed-action-btn {
  top: 80px;
}

.fuenteVerde {
  color: #00b134;
}

.fa-ban {
  color: #aaaaaa;
}

.fuenteRojo {
  color: #d60100;
}

.fuenteGuardar {
  background-color: #7a0f19;
  color: white;
}

.fa {
  font-size: 1.4em;
}

/*.modal {*/
/*  min-height: 80%;*/
/*}*/

/*.input-field {*/
/*  min-height: 50px;*/
/*}*/

.titulo-card {
  font-size: 1.2em;
}

.card-panel {
  border-radius: 10px;
  padding-top: 15px;
  padding-bottom: 15px;
  overflow: auto;
}

.button-box .button-box-int {
  align-items: start;
  display: inline-flex;
  flex-wrap: wrap;
  height: 50px;
}

.button-container .btn-large i.material-icons {
  margin-right: 8px;
}

@media (max-width: 800px) {
  table {
    font-size: 0.8rem;
  }

  th {
    height: 63px;
    max-height: 63px;
  }

  td {
    height: 63px;
    max-height: 63px;
  }

  .titulo {
    font-size: 2rem;
  }
}

.cursorOn {
  color: #084c63;
  cursor: pointer;
}

.main-container {
  width: 94%;
  margin: 0 auto;
}

.input-date {
  margin: 0.7rem 0 0 0;
}


.row {
  padding: 1rem;
}


</style>